module.exports = __webpack_public_path__ + "static/img/publicar curso 1680x1050.de18dee.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/landing/capacitador/publicar/publicar curso 1680x1050.jpg
// module id = YUkv
// module chunks = 47